<template>
  <div class="full-window">
    <EmbedOverlay />
  </div>
</template>

<script>
import EmbedOverlay from "@/components/mediasoup-event/EmbedOverlay.vue";

export default {
  name: "Embed",
  components: {
    EmbedOverlay,
  },
};
</script>

<style scoped>
.full-window {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #121c2e;
  z-index: 999 !important;
}
</style>
